<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rba9nu/tc-custom/9781426818233.jpg?1740526258873" alt="This image is the cover for the book Lord Hawkridge's Secret"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lord Hawkridge's Secret
      </h1>
      <p class="bookDescription body article font2">
        <p>Miss Emily Stapleton broke her engagement to Lord Sebastian Hawkridge nearly five years ago upon discovering that he was in love with another. Now she's become entangled in something dark and dangerous and Sebastian is back in her life againas her guardian! <br/><br/>How will Emily respond to him when all the secrets of the past are finally revealed?<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anne Ashley
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?284f1e0a